<template>
    <div class="tile-content">
        <div class="tile-subtitle">
            <h3>Dynamic Currency Conversion</h3>
        </div>
        <p class="stack-m">Dynamic Currency Conversion allows you to make an offer to your customer when they are
            attempting to pay in their non-native currency, and when your gateway account supports your native currency.
            Learn more about it <a
                href="https://help.rebilly.com/rebilly-advanced/dynamic-currency-conversion"
                target="_blank">here</a>.</p>
        <div class="grid-content">
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Dynamic Currency Conversion Markup"
                    help-text="In basis points. E.g. '200'"
                    :value="dccMarkup"
                    :validate="$v.dccMarkup"
                    @input="updateMarkup"
                />
            </div>
            <div class="grid-item grid-item-full">
                <v-select
                    label="Excluded Dynamic Currency"
                    placeholder="Select currencies"
                    :options="currenciesList"
                    :multiple="true"
                    :allow-empty="true"
                    :value="excludedDccQuoteCurrencies"
                    @input="updateExclusions"
                    help-text="Select currencies for which you do not want to offer DCC. Leave empty to enable for all currencies."
                />
            </div>
            <div class="grid-item grid-item-full">
                <v-select
                    label="Force Dynamic Currency Conversion"
                    placeholder="Select a currency"
                    :options="currenciesList"
                    :allow-empty="true"
                    :value="dccForceCurrency"
                    @input="updateForceDcc"
                    help-text="When selected, each transaction will be converted into the forced currency."/>
            </div>
        </div>
    </div>
</template>

<script>
    import {CURRENCIES_LIST} from '@/data/currencies';
    import {vSelect} from '@/components/form';
    import {integer, between} from 'vuelidate/lib/validators';
    import validationMixins from '../validation-mixins';

    export default {
        name: 'dynamic-currency-conversion',
        mixins: [validationMixins],
        components: {vSelect},
        props: {
            dccMarkup: {
                type: [Number, String],
            },
            excludedDccQuoteCurrencies: {
                type: Array,
            },
            dccForceCurrency: {
                type: String,
            },
        },
        data() {
            return {
                currenciesList: [...CURRENCIES_LIST],
            };
        },
        validations: {
            dccMarkup: {integer, between: between(-10000, 10000)},
        },
        methods: {
            updateMarkup(value) {
                this.$v.$touch();
                this.$emit('input', {
                    dccMarkup: value,
                    excludedDccQuoteCurrencies: this.excludedDccQuoteCurrencies,
                    dccForceCurrency: this.dccForceCurrency,
                });
            },
            updateExclusions(exclusions) {
                this.$emit('input', {
                    dccMarkup: this.dccMarkup,
                    excludedDccQuoteCurrencies: exclusions,
                    dccForceCurrency: this.dccForceCurrency,
                });
            },
            updateForceDcc(currency) {
                this.$emit('input', {
                    dccMarkup: this.dccMarkup,
                    excludedDccQuoteCurrencies: this.excludedDccQuoteCurrencies,
                    dccForceCurrency: currency,
                });
            },
            validate() {
                this.$v.$touch();
                return !this.$v.dccMarkup.$error;
            },
            getValidationAggregatorDefinition() {
                return {
                    name: 'dynamic-currency-conversion',
                    rules: [
                        {
                            name: 'DCC Markup should be a number between -10000 and 10000',
                            delegate: () => this.$v.dccMarkup.$error,
                        },
                    ],
                };
            },
        },
    };
</script>
